import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components'
import FeatherIconWrapper from '../Icons/FeatherIconWrapper'
import SlidersIcon from '../Icons/Sliders/Sliders'
import SearchIcon from '../Icons/Search/Search'
import { ActiveFilterIndicatorColor, WerfenColorMid, White, WerfenFormFieldColor, WerfenFormTextColor } from '../../Constants/ColorChart'
import { refreshSearch, setSearchString, setSuggestString } from '../../../actions/search';
import { connect } from "react-redux";
import { hideAutoSuggest, showAutoSuggest, showPanel } from "../../../actions/ui";
import { bindActionCreators } from "redux";
import { triggerSearchAnalytics, triggerVisitToSearchAnalytics } from "../../../../web/Utils/utils";
import useDebounce from "../Sensors/useDebounce";
import SuggestionBox from "../SuggestionBox/SuggestionBox";
import {
    IconContainer
} from '../ResultTable/Components/ResultRow/StyledResultRow';

/*
 *  @Description:   Stateless component that renders a SearchBarInput with a magnet icon.
 */

const locationIsIL = window.location.host === "docs.instrumentationlaboratory.com";

const SearchBarInput = styled.input`
    border: none;
	font-size: 15pt;
	background: ${ props => props.background ? props.background : WerfenFormFieldColor };
	color: ${ props => props.color ? props.color : WerfenFormTextColor };
	padding-left: 2%;
	padding-right: 2%; 
    height: 100%;
    margin-right: 0px;
    display: flex;
    flex-grow: 1;
    @media (max-width: 992px) {
    	font-size: 12pt !important;
    	overflow: hidden;
    	text-overflow: ellipsis
    }
	&::placeholder{
		color: ${ WerfenFormTextColor };
	}
	&:focus{
		outline: none;
	}
`

const IconDiv = styled.div`
    padding-top: 0px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
    @media (max-width: 992px) {
        .iconContainer > svg,
        & > svg {
            width: 34px!important;
            height: 34px!important;
            margin: 0 4px;
        }
    }
    span.filters {
        display: inline-block;
        width: 22px;
        height: 22px;
        background: ${ ActiveFilterIndicatorColor };
        border-radius: 100px;
        color: ${ ActiveFilterIndicatorColor };
        display: flex;
        align-items: center;
        justify-content: center;
        border: 4px solid ${ White };
        font-weight: bold;
        position: absolute;
        bottom: 4px;
        left: 8px;
        font-size: 13px;
        .SearchBarContainer & {
           bottom: 8px;
           left: 7px;
        }
    }
`;

const StyledDiv = styled.div`
    /* clears the 'X' from Internet Explorer */
    input[type=search]::-ms-clear {  display: none; width : 0; height: 0; }
    input[type=search]::-ms-reveal {  display: none; width : 0; height: 0; }
    
    /* clears the 'X' from Chrome */
    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration { display: none; }

    -webkit-app-region: no-drag;
    display:flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    flex-grow:0;
    background: ${ WerfenColorMid };
    ${ props => props.extraStyle && props.extraStyle }
    @media (max-width: 992px) {
        margin-left: 0!important;
    }
`;

const SearchBar = (props) => {
    const history = useHistory();
    const [ searchString, setSearchString ] = useState( props.searchString || props.suggestString );
    const debouncedSearchString = useDebounce(searchString, 250)

    const {
        placeholder,
        iconBottom,
        extraStyle,
        buttonBackgroundColor,
        buttonIconColor,
        BUfilterArray,
        DfilterArray,
        FEfilterArray,
        TypeFilterArray,
        DateFilterArray,
        isNetworkAvailable,
        // isServerReachable
    } = props;

    const canConnect = isNetworkAvailable //&& isServerReachable;
    const propsBusinessUnits = props.businessUnits || []
    const propsDepartments = props.departments || []
    const propsFileExtensions = props.fileExtensions || []

    useEffect( () => {
        const currentPathname = history.location.pathname;
        if(currentPathname.indexOf("/search/") !== -1) {
            const searchQuery = currentPathname.replace("/search/","");
            const encodedQuery = encodeURIComponent(searchQuery).split("%20").join(" ");
            triggerVisitToSearchAnalytics(searchQuery, props.session.user);
            if(encodedQuery.trim() !== "") {
                if ( props.searchString === "" || props.searchString === "undefined" || props.searchString === undefined ) {
                    props.setSearchString( encodedQuery );
                    setSearchString(encodedQuery);
                }

                if ( props.suggestString === "" || props.suggestString === "undefined" || props.suggestString === undefined ) {
                    props.setSuggestString( encodedQuery );
                    setSearchString(encodedQuery);
                }

                if (
                    searchString === "" ||
                    searchString === undefined ||
                    searchString === "undefined"
                ) {
                    setSearchString(encodedQuery)
                }
            }
        } else {
            props.setSearchString( "" );
            props.setSuggestString( "" );
        }

        window.addEventListener('mousedown', closeDropdown, false);
        
        return () => {
            window.addEventListener('mousedown', closeDropdown, false);
            window.addEventListener('mousedown', closeDropdown, true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    useEffect( () => {
            setSuggestString( debouncedSearchString );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ debouncedSearchString ] );

    const closeDropdown = (event) => {

        if ( event.target.parentElement === null || (event.target.parentNode.classList !== undefined && (!(event.target.classList.contains( "searchElement" ) || event.target.parentNode.classList.contains( "searchElement" ))) )) {
            props.hideAutoSuggest();
        }
    }

    const triggerSearch = () => {
        const currentPathname = history.location.pathname;
        if ( currentPathname.indexOf( "/search" ) === -1 && props.searchString !== "" ) {

            triggerSearchAnalytics( props.searchString, props.session.user );
            props.history.push( "/search/" + props.searchString );

        } else {
            const currentSearchString = document.querySelectorAll( ".searchElement.searchBarInput" )[0].value;
            triggerSearchAnalytics( currentSearchString, props.session.user );
            props.setSearchString( encodeURIComponent( currentSearchString ).split( "%20" ).join( " " ) );
            history.push( "/search/" + encodeURIComponent( currentSearchString ) );
            props.refreshSearch();
        }

        props.hideAutoSuggest();
        props.refreshSearch();
    }

    const setSuggestString = (value) => {
        props.setSuggestString( encodeURIComponent( value ).split( "%20" ).join( " " ) );
    }

    const handleOnChangeEvent = (event) => {
        const targetValue = event.target.value;
        setSearchString(targetValue); 
    }

    const handleOnFocusEvent = (event) => {
        props.showAutoSuggest();
    }
    // const handleOnBlurEvent = (event) => {
    //     // event.stopPropagation();
    //     console.log("blur")
    //     // props.hideAutoSuggest();
    // }

    const updateSearchString = (value) => {
        setSearchString(value);
    }
    const showIconFilter = BUfilterArray.length > 0
        || DfilterArray.length > 0
        || FEfilterArray.length > 0
        || TypeFilterArray.length > 0
        || DateFilterArray.length > 0;

    return (
        <>
            <StyledDiv id="SearchBar" extraStyle={ extraStyle }>
                <SearchBarInput
                    id={"searchBar"}
                    placeholder={ placeholder }
                    value={ decodeURIComponent( searchString ) || "" }
                    className={ "searchElement searchBarInput" }
                    background={ props.background }
                    color={ props.color }
                    type={ "search" }
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    onChange={ ( event ) => handleOnChangeEvent( event ) }
                    onFocus={ ( event ) => handleOnFocusEvent( event ) }
                    // onBlur={(event)=>handleOnBlurEvent(event)}
                    onKeyPress={ ( event ) => {
                        if ( event.key === 'Enter' ) {
                            triggerSearch()
                        }
                    } }/>
                <IconDiv style={ { "background": buttonBackgroundColor } }>
                    { showIconFilter && <span className={ "filters" }/> }
                    {
                        ((propsBusinessUnits.length > 1) || (propsDepartments.length > 1) || (propsFileExtensions.length > 1)) &&
                        canConnect && !locationIsIL &&
                        process.env.REACT_APP_SEE_FILTERS === "1" &&
                        <IconContainer
                            className={ "iconContainer" + (iconBottom ? ' iconBottom' : '') }
                            data-title={ "Add filters to your search" } >
                            <FeatherIconWrapper
                                color={ buttonIconColor }
                                width="40px"
                                onClick={ props.showPanel }
                                iconStyle="display: inline-block; margin-top: -3px; stroke-width: 1.3px; padding: 8px; width: 40px; height: 40px; &:hover{ cursor: pointer }"
                                Icon={ SlidersIcon }
                            />
                        </IconContainer>
                    }
                    <IconContainer
                        className={ "iconContainer" + (iconBottom ? ' iconBottom' : '') }
                        data-title={ "Search" } >
                        <FeatherIconWrapper
                            color={ buttonIconColor }
                            width="40px"
                            onClick={ () => triggerSearch() }
                            iconStyle="display: inline-block; margin-top: -3px; stroke-width: 1.3px; padding: 6px; width: 40px; height: 40px; &:hover{ cursor: pointer }; overflow: visible!important"
                            Icon={ SearchIcon }
                        />
                    </IconContainer>
                </IconDiv>
            </StyledDiv>
            <SuggestionBox
                history={ history }
                updateSearchString={updateSearchString}
            />
        </>

    )
}


const mapStateToProps = ( state ) => (
    {
        businessUnits: state.settings.businessUnits,
        departments: state.settings.departments,
        fileExtensions: state.settings.fileExtensions,
        session: state.session,
        BUfilterArray: state.filters.BUfilterArray,
        DfilterArray: state.filters.DfilterArray,
        FEfilterArray: state.filters.FEfilterArray,
        TypeFilterArray: state.filters.TypeFilterArray,
        DateFilterArray: state.filters.DateFilterArray,
        searchString: state.search.searchString,
        suggestString: state.search.suggestString,
        showAutoSuggestPanel: state.ui.showAutoSuggestPanel,
        isNetworkAvailable: state.sensors.isNetworkAvailable,
        isServerReachable: state.sensors.isServerReachable,
    });

const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators( {
        refreshSearch: refreshSearch,
        setSearchString: setSearchString,
        setSuggestString: setSuggestString,
        showPanel: showPanel,
        showAutoSuggest: showAutoSuggest,
        hideAutoSuggest: hideAutoSuggest,
    }, dispatch );
};

export default connect( mapStateToProps, mapDispatchToProps )( SearchBar );